import '@unocss/reset/tailwind-compat.css';
import 'ant-design-vue/dist/reset.css';
import 'uno.css';
import '@mts/design/index.less';
import { createApp } from 'vue';
import { setupGlobComponents } from '@mts/components';
import { setupGlobDirectives } from '@mts/directives';
import { setupI18n } from '@mts/locales/setupI18n';
import { setupErrorHandle } from '@mts/logics/error-handle';
import { initAppConfigStore } from '@mts/logics/initAppConfig';
import { registeAppEvents } from '@mts/adapter';
import { router, setupRouter } from '@/router';
import { setupRouterGuard } from '@/router/guard';
import { setupStore } from '@/store';
import App from './App.vue';

async function bootstrap() {
  const app = createApp(App);

  // Configure store
  // 配置 store
  setupStore(app);

  // Initialize internal system configuration
  // 初始化内部系统配置
  initAppConfigStore();

  registeAppEvents();

  // Register global components
  // 注册全局组件
  setupGlobComponents(app);

  // Multilingual configuration
  // 多语言配置
  // Asynchronous case: language files may be obtained from the server side
  // 异步案例：语言文件可能从服务器端获取
  await setupI18n(app);

  // Configure routing
  // 配置路由
  setupRouter(app);

  // router-guard
  // 路由守卫
  setupRouterGuard(router);

  // Register global directive
  // 注册全局指令
  setupGlobDirectives(app);

  // Configure global error handling
  // 配置全局错误处理
  setupErrorHandle(app);

  requestIdleCallback(() => {
    app.mount('#app');
  });
}

bootstrap();
